// src/pages/Suggestions.js
import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";

export default function Suggestions() {
  return (
    <div className="min-h-screen bg-[#EAEEFE]">
      <Sidebar />

      <main className="px-4 md:px-8 pt-6 pb-24 md:pb-10 md:pl-[110px]">
        <header className="flex items-center justify-between mb-6">
          <h1 className="text-3xl md:text-4xl font-bold">Suggestions d’achat</h1>
          <Link to="/dashboard" className="btn-secondary h-11 px-4">← Retour</Link>
        </header>

        <section className="card p-8 text-center">
          <div className="text-5xl mb-3">🚧</div>
          <h2 className="text-xl md:text-2xl font-semibold mb-2">Page en cours de construction</h2>
          <p className="text-sm md:text-base text-neutral-600 mb-6">
            Nous finalisons le moteur de suggestions basé sur ta garde-robe et la météo.
            Reviens bientôt pour découvrir des idées d’achats personnalisées.
          </p>

          {/* Barre de progression décorative */}
          <div className="mx-auto max-w-md w-full">
            <div className="w-full bg-neutral-200 rounded-full h-2 overflow-hidden">
              <div className="h-2 rounded-full bg-brand-600 animate-pulse" style={{ width: "45%" }} />
            </div>
            <div className="mt-2 text-xs text-neutral-500">Progression estimée</div>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/dressing" className="btn-primary h-11 px-5">Voir le dressing</Link>
            <Link to="/dashboard" className="btn-secondary h-11 px-5">Aller au dashboard</Link>
          </div>
        </section>
      </main>
    </div>
  );
}
